import './legacy-showtime-runtime';

if (typeof window.getGenre !== 'function') {
  window.getGenre = function() {
    const currentGenre = window.Cookies.get('genre');

    return typeof currentGenre === 'undefined' ? 'all' : currentGenre;
  };
}

if (typeof window.setGenre !== 'function') {
  window.setGenre = function(genre) {
    window.Cookies.set('genre', genre, { expires: 365 });
  };
}

if (typeof window.getLanguage !== 'function') {
  window.getLanguage = function() {
    const currentLanguage = window.Cookies.get('language');

    return typeof currentLanguage === 'undefined' ? 'all' : currentLanguage;
  };
}

if (typeof window.setLanguage !== 'function') {
  window.setLanguage = function(language) {
    window.Cookies.set('language', language, { expires: 365 });
  };
}

if (typeof window.getSort !== 'function') {
  window.getSort = function() {
    const currentSort = window.Cookies.get('sort');

    return typeof currentSort === 'undefined' ? 'popular' : currentSort;
  };
}

if (typeof window.setSort !== 'function') {
  window.setSort = function(sort) {
    window.Cookies.set('sort', sort, { expires: 365 });
  };
}
